<template>
  <apollo-mutation
    :mutation="changeUsername"
    :update='changedUsername'
    class="w-full p-2 md:p-5 pbc-z-level-4"
    @done='$emit("close")'
    :variables="{username}">

    <template v-slot="{mutate,loading,error,result}" >

    <apollo-query :query='checkUsernameValidQuery'
                  :variables='{username}'>
      <template v-slot='{isLoading, result: {error, data}}'>

      <pbc-modal :disable-title='true' :full-height="false">

        <template #default='{}'>
          <div class="w-full bg-gray-800 bg-no-repeat" style="
                      background-blend-mode: multiply;
                      background-position: center center;
                      background-size: contain;
                      background-image: url('/img/PBC_Meme.svg');
                      ">
            <div class="p-10 py-12 flex flex-col flex-wrap justify-center content-center">
              <div class="z-60 mt-4">
                <h1 class="text-white font-bold text-2xl mb-2">Welcome!</h1>
                <h1 class="text-white text-xl">What should we</h1>
                <h2 class="text-blue-300 font-bold text-2xl -mt-3">call you?</h2>
              </div>
            </div>

            <div v-if='loading' class="spinner" />
            <div class="border-box flex w-full overflow-hidden px-2 overflow-hidden pb-3">
              <input :value='username'
                      @input="e => username = e.target.value"
                      class="flex-1 shadow appearance-none border rounded py-1 px-2 text-gray-700 leading-tight focus:outline-none w-auto focus:shadow-outline overflow-hidden inline-block"
                      type="text"
                      placeholder="Enter your username.">

              <pbc-button v-if='isLoading'> 
                <div class="w-6 h-6 spinner" />
              </pbc-button>
              <pbc-button v-else-if='data && data.checkUsernameValid'
                          class="bg-green-400 text-white">
                <check />
              </pbc-button>
              <pbc-button v-else
                          class="bg-red-400 text-white">
                <close />
              </pbc-button>
            </div>
          </div>
        </template>

        <template #controls='{}'>
          <div class="py-3 w-full flex justiy-center inline-flex justify-center border-t border-solid border-grey-500">
            <pbc-button class="bg-green-400" :disabled='!(data && data.checkUsernameValid)' @click='mutate'>
              <check class="mx-2"/>
              <span class="mr-2">Save</span>
            </pbc-button>
          </div>
        </template>
      </pbc-modal>

        </template>
      </apollo-query>
    </template>
  </apollo-mutation>

</template>
<script>
import { whoamiQuery } from '@/gql/Queries.js';
import gql from 'graphql-tag';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
import { ApolloMutation, ApolloQuery } from 'vue-apollo';
export default {
  data() {
    return {
      username: '',
      usernameValid: false,
      savedUsername: true,
      changeUsername: gql(`
        mutation changeUsername(
          $username: String!
          )  {

          changeUsername(
            username: $username
          )  {
            id
            username
          }
        }
      `),
      checkUsernameValidQuery: gql(`
        query checkUsernameValid(
          $username: String!
        ) {
          checkUsernameValid(
            username: $username
          )
        }
      `)
    }
  },
  components:{
    Check,
    Close,
    ApolloMutation,
    ApolloQuery
  },
  mounted() {
    this.$ana.track({
      eventCategory:'register',
      eventAction:'showUsernameDialog'
    });
  },
  methods: {
    async changedUsername(store, {data: { changeUsername }} ) {
      console.log('changeUsername', changeUsername);
      const query = {
        query:whoamiQuery,
      }

      const data = store.readQuery(query);
      console.log('data', data);
      data.whoami.username = changeUsername.username;
      store.writeQuery({
        ...query,
        data
      })
      this.savedUsername = true;

      this.$ana.track({
        eventCategory:'register',
        eventAction:'changedUsername',
        extra:{
          username: changeUsername.username
        }
      });
    },

  },
  watch: {
    username(nv) {
      this.usernameValid = !!nv.length;
      this.$ana.track({
        eventCategory:'register',
        eventAction:'typeUsername',
        extra:{
          nv
        }
      });
    },
    savedUsername(nv) {
      if (nv) {
        this.$emit('close');
      }
    }
  }
}
</script>
